import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface OverflowTextProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  toolTip?: string;
}

export const EllipsisText = ({children, className, style, toolTip}: OverflowTextProps) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{toolTip ? toolTip : children}</Tooltip>}
      delay={{show: 1000, hide: 200}}
    >
      <span className={"text-truncate " + className} style={style}>
        {children}
      </span>
    </OverlayTrigger>
  );
};
